<div class="dialog-container">
  <div class="dialog-header">
    <h1 mat-dialog-title class="dialog-title">Information</h1>
    <button mat-dialog-close matIconButton aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    <div class="account">
      <div class="account-info">
        <div><strong>Name:</strong> {{ name }}</div>
        <div><strong>Email:</strong> {{ email }}</div>
        <a href="privacy-policy">Privacy Policy</a>
      </div>
      <div class="account-buttons">
        <button matIconButton (click)="editAccount()" matTooltip="Edit/delete account">
          <mat-icon>edit</mat-icon>
        </button>
        <button matIconButton (click)="logout()" matTooltip="Logout">
          <mat-icon>logout</mat-icon>
        </button>
      </div>
    </div>

    @let dataSpaceUsedState = dataSpaceUsedState$();
    @if (dataSpaceUsedState.status === 'loading') {
      <div class="spinner-container">
        <mat-spinner diameter="50"></mat-spinner>
      </div>
    } @else if (dataSpaceUsedState.status === 'error') {
      <span class="no-data">Account space used not available</span>
    } @else {
      <div>
        <app-chart [chartConfig]="userDiskSpaceChart$()" class="disk-space-chart"> </app-chart>
      </div>
    }

    <div><strong>Version:</strong> {{ versionInfo }}</div>
    @if (devOrLocalhost.getValue() != 'Production') {
      <mat-slide-toggle
        (change)="changeTheme($event)"
        labelPosition="before"
        [checked]="this.themeService.currentTheme() == 'dark'"
        >Dark mode</mat-slide-toggle
      >
    }
  </mat-dialog-content>
</div>
